import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as _ from 'lodash';

@Injectable()
export class FlowService {

    states = {}
    unsaved;
    className = 'FlowService';

    constructor() {

    }

    saveState(state, cdState) {
        this.states[cdState] = state;
    }

    deleteState(cdState) {
        delete this.states[cdState];
    }

    getState(cdState, remove = true) {
        let state = { ...this.states[cdState] }
        if (remove) {
            this.deleteState(cdState);
        }
        return state;
    }

    isSomeStateActive() {
        return _.size(_.keys(this.states)) > 0;
    }

    setUnsaved(flag) {
        this.unsaved = flag;
    }

    getUnsaved() {
        return this.unsaved;
    }
}